module.exports = __webpack_public_path__ + "img/kravag.922b9e1d.png";